import { gql } from '@apollo/client';

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
  query searchCustomerByNumber($input: ViewCustInput) {
    customer(input: $input) {
      cust_number
      cust_ref_number
      cust_type {
        code
        value
      }
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
        acc_holder
        micr_code
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      indv_detail {
        title {
          code
          value
        }
        first_name
        middle_name
        full_name
        surname
        date_of_birth
        id_proof_type {
          code
          value
        }
        id_proof_number
        pan_card_number
        nationality {
          code
          value
        }
        occupation {
          code
          value
        }
        gender {
          code
          value
        }
        marital_status {
          code
          value
        }
        gst_number
        employeeNumber
      }
      org_detail {
        org_name
        org_type {
          code
          value
        }
        reg_number
        tan_number
        gst_number
        contact_mob
        contact_name
        contact_email
      }
      contact {
        email
        mobile
        telephone
        fax_number
        alt_telephone
        alt_mobile
      }
    }
  }
`;

export const VIEW_PROPOSALS = gql`
  query viewProposal($input: viewProposalInput) {
    viewProposal(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      policyNumber
      selectedPlanName
      selectedPlanCode
      sumInsured
      deductSumInsured
      tenure
      isApplicableForPayment
      isHealthDeclarationSelected
      proposalPaymentType
      zone
      employeeNumber
      businessType
      quoteNumber
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      prevInsuranceDetails {
        prevInsurerName
        prevPolicyNo
        prevPolicySI
        noOfClaim
        claimAmount
        prevPolicyStartDate
        prevPolicyEndDate
        insuredRelationship
        insuredName
        cbAmount
        prevClaimLodged
      }
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      portabilityDetails {
        insuredRelationship
        memberId
        memberName
        sumInsuredIncCumBonusifany
        thirtyDaysWaitingPeriod
        twoYearsWaitingPeriod
        ped4YearsWaitingPeriod
      }
      renewalMandateDetails {
        renewalPaymentMandate
        renewalPaymentMandateTakenInNameOf
        termForMandateOpted
        typeOfDebit
        accountNumber
        destinationBankName
        destinationIfscCode
        destinationMicrCode
        branchName
        mandateAmount
        finalCollectionDate
        destinationBankAccountType
      }
      coverType
      policy {
        startDate
        endDate
        time
      }
      premium {
        breakup {
          relationship
          age
          gender
          premium
        }
        basePremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
      }
      insuredDetails {
        relationship
        gender
        title
        dob
        age
        firstName
        middleName
        lastName
        maritalStatus
        height
        weight
        occupation
        otherOccupation
        insuredrelationshipwithproposer
        pedWaitingPeriod
        memberStatus
        ppcTestLevel
        cbBonusPct
        isPortabilityRequired
        memberID
        covers {
          name
          index
        }
      }
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithInsured
        relationshipWithAppointee
        nameOfAppointee
      }
      medicalQuestionaire {
        relationship
        areYouCurrentlyInGoodMentalAndPhysicalHealth
        questions {
          srNo
          answer
        }
      }
    }
  }
`;
export const VIEW_PROPOSALS_SCPA = gql`
  query viewProposaSCPA($input: viewProposalInput) {
    viewProposalSCPA(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      policyNumber
      quoteNumber
      selectedPlanName
      selectedPlanCode
      sumInsured
      deductSumInsured
      tenure
      isApplicableForPayment
      isHealthDeclarationSelected
      proposalPaymentType
      businessType
      zone
      product {
        productCode
        productName
      }
      prevInsuranceDetails {
        prevInsurerName
        prevPolicyNo
        prevPolicySI
        noOfClaim
        claimAmount
        prevPolicyStartDate
        prevPolicyEndDate
        insuredRelationship
        insuredName
      }
      coverType
      policy {
        startDate
        endDate
        time
      }
      premium {
        breakup {
          relationship
          age
          gender
          premium
        }
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
      }
      insuredDetails {
        
        ChasisNo
        EngineNo
        VehicleMake
        VehicleModel
        relationship
        vehicleRegNo
      }
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithInsured
        relationshipWithAppointee
        nameOfAppointee
      }
      
    }
    
  }
`;
export const VIEW_PROPOSAL_TW = gql`
  query viewProposalTwoWheeler($input: viewProposalInput) {
    viewProposalTW(input: $input) {
      proposalNumber
      tenure
      proposalStatus
      policyNumber
      adjustmentIRF2
      IRF2comments
      isApplicableForPayment
      isVehicleInspectionNeeded
      premium {
        idv1
        idv3
        idv2
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        vehicleAge
        claimFreeYear
        creditScore
        NCB
      }
      customerID
      product {
        productCode
        productName
      }
      productType
      businessType
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      rtoDetails {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      vehicleDetails {
        make {
          code
          value
        }
        model {
          code
          value
        }
        variant {
          code
          value
        }
        fuelType
        seatingCapacity
        cubicCapacity
        segmentType
        gvw
        manufactureYear
        regPurchaseDate
        engineNumber
        chasisNumber
        registrationNumber
        preInspectionNumber
      }
      totalIDV
      bodyIDV
      firstYearIDV
      irf1
      isTrailerRequired 
      towedby
      trailerDetails{
        make
        model
        regnumber
        ChassisNumber
        SI
        yearofmanufacture
      }
      isPreviousPolicy
      prevInsuranceDetails {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
        insurerNameTP
        insurerAddressTP
        policyNumberTP
        expiryDateTP
        startDateTP
      }
      previousClaims {
        totalClaimCount
        claimsInYear1
        claimsInYear2
        claimsInYear3
        prevNCBSlab
        totalClaimAmount
        claimFreeYear
      }
      financerDetails {
        vehicleOwned
        financerName
        financerAddress
        financerAgreementType
        loanAccountNumber
        fileNumber
      }
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      creditScore {
        discountOpted
        idProofType
        idProofNumber
        creditScore
      }
      proposerPincode
      voluntaryDeductibleAmt
      NCB
      quoteNumber
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithAppointee
        nameOfAppointee
      }
      leadGenerator
      proposalPaymentType
      policy {
        startDate
        endDate
        time
      }
      lob {
        lobCode
        lobName
      }
      userID
    }
  }
`;

export const VIEW_PROPOSAL_IPA = gql`
  query viewProposalIpa($input: viewProposalInput) {
    viewProposalIpa(input: $input) {
      customerID
      proposalNumber
      policyNumber
      proposalStatus
      productCode
      isApplicableForPayment
      riskCategory
      businessType
      memberType
      sumInsured
      userID
      intermediary {
        code
        fieldUserCode
        location
        fieldUserName
      }
      policy {
        startDate
        endDate
        time
      }
      insuredDetails {
        relationship
        title
        gender
        dob
        age
        firstName
        middleName
        lastName
        maritalStatus
        height
        weight
        occupation
        otherOccupation
      }
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithInsured
        relationshipWithAppointee
        nameOfAppointee
      }
      prevInsurance {
        prevInsurerName
        prevPolicyNo
        prevPolicySI
        claimAmount
        prevPolicyStartDate
        prevPolicyEndDate
        insuredRelationship
        insuredName
        totalPremium
        membershipNumberofPastPolicy
        prevClaimLodged
      }
      policyStartDate
      quoteNumber
      isEmployeeDiscount
      groupOrg
      employeeNumber
      premiumData {
        discount {
          name
          amount
        }
        loading {
          name
          amount
        }
        netPremium
        stampDuty
        gst
        totalPremium
      }
      proposalPaymentType
      isInsuredSalariedPerson
      annualIncome
      plan {
        name
        code
        subPlan {
          name
          code
          tenure {
            code
            value
          }
        }
      }
      covers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      proposerPincode
    }
  }
`;
export const COVERS_IPA = gql`
  query applicableCoversIPA($input: ApplicableCoversIPAInput) {
    applicableCoversIPA(input: $input) {
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
    }
  }
`;
export const APPLICABLE_COVERS_WORKMEN_COMPENSATION = gql`
  query workmenCompCovers {
    workmenCompCovers {
      riskType
      covers {
        name
        index
        selected
        isMultipleGroupOfAttribute
        keyword
        attributes {
          name
          value
          displayName
          fieldType
          fieldDataType
          defaultValue
          showOnScreen
          dataValues {
            code
            value
          }
        }
      }
    }
  }
`;
export const INTERMEDIARY_LIST = gql`
  query IntermediaryList {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS = gql`
  query previousPolicyDropdownDetails($productCode: StrictNumber) {
    PRD_PreviousPolicyTypeList(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousPolicyTermList(productCode: $productCode) {
      code
      value
    }
    PRD_TotalClaimCountList(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear1List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear2List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear3List(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousYearNCBSlabList(productCode: $productCode) {
      code
      value
    }
  }
`;

export const FINANCER_DROPDOWN_DETAILS = gql`
  query financerDetails($productCode: StrictNumber) {
    PRD_FinancerAgreementType(productCode: $productCode) {
      code
      value
    }
    PRD_IsYourVehicle(productCode: $productCode) {
      code
      value
    }
  }
`;

export const LOB_PRODUCT_LIST = gql`
  query lobProductList {
    lobProductList {
      lob_name
      lob_code
      products {
        product_name
        product_code
        product_types {
          code
          value
        }
        linkTo
      }
    }
  }
`;

export const APPLICABLE_COVERS = gql`
  query applicableCovers($input: ApplicableCoversInput) {
    applicableCovers(input: $input) {
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
    }
  }
`;

export const TWO_WHEELER_BUSINESS_TYPE = gql`
  query getTwoWheelerBusinessType($filter: BusinessTypeInput) {
    getTwoWheelerBusinessType(filter: $filter) {
      code
      value
    }
  }
`;

export const GET_MEDICAL_QUESTIONS = gql`
  query getMedicalQuestions($input: productCodeInput) {
    productQuestionList(input: $input) {
      srNo
      label
      isChkReq
      isChkTxtReq
      isParent
      condToChild
      childQuesNo
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const RENEWAL_MANDATE_DETAILS = gql`
  query renewalMandateData($productCode: StrictNumber) {
    PRD_TermForMandate(productCode: $productCode) {
      code
      value
    }
    PRD_RenewalPaymentMandateTakenInTheNameOf(
      productCode: $productCode
    ) {
      code
      value
    }
    typeOfDebit {
      code
      value
    }
    destinationBankAccountType {
      code
      value
    }
  }
`;

export const LOOKUP_FIELDUSER = gql`
  query lookupFieldUser($filter: UserSearchFilter) {
    associatedEntityLookup(filter: $filter) {
      fieldUserName
    }
  }
`;
export const GET_PLAN_COVER_DETAILS = gql`
  query getPlanCoverDetails($input: planAndCoversInput) {
    planAndCovers(input: $input) {
      name
      code
      covers {
        name
        index
      }
      packs {
        name
        index
        addOnCovers {
          name
          index
          selected
        }
      }
    }
  }
`;
export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;
export const VIEW_PROPOSAL_WMC = gql`
query wmcViewProposal($input: viewProposalInput) {
  wmcViewProposal(input: $input) {
    customerID
    proposalNumber
    proposalStatus
    policyNumber
    proposalEndDate
    isApplicableForPayment
    premium{
      netPremium
      gst
      stampDuty
      totalPremium
      loading{
        name
        amount
      }
      discount{
        name
        amount
      }
      warningMsg
    }
    loadingPercent
    discountPercent
    quoteNumber
    intermediaryDetails{
      code
      location
      fieldUserCode
      fieldUserName
    }
    policyStartDate
    policyTenure
    businessOfInsured
    industryCategory{
      code
      value
    }
    industrySubCategory{
      code
      value
    }
    policyType{
      code
      value
    }
    locationType{
      code
      value
    }
    locationDetails{
      address_line1
      address_line2
      address_line3
      land_mark
      city
      district
      state
      pin_code
      allIndiaBasisDesc
    }
    proposalType
    lob{
      lobCode
      lobName
    }
    product{
      productCode
      productName
    }
    employeeDetails{
      employeeType{
        code
        value
      }
      employeeName
      numberOfEmployee
      monthlyIncome
    }
    riskCovers {
      riskType
      covers {
        name
        index
        selected
        isMultipleGroupOfAttribute
        keyword
        attributes {
          name
          value
          displayName
          fieldType
          fieldDataType
          defaultValue
          showOnScreen
          dataValues {
            code
            value
          }
        }
      }
    }
    uploadedDocuments {
      documentType {
        code
        value
      }
      documentName
      documentSize
      base64EncodedDoc
    }
    clauses{
      default
      userDefined
    }
    warranties{
      default
      userDefined
    }
    conditions{
      default
      userDefined
    }
    exclusions{
      default
      userDefined
    }
    stageIndex
  }
}
`;

export const VIEW_PROPOSAL_FIRE = gql`
  query viewProposalFire($input: viewProposalInput) {
    viewProposalFire(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      policyNumber
      quoteNumber
      lob {
        lobCode
        lobName
      }
      product {
        productCode
        productName
      }
      businessOfInsured
      prevClaimExpDtls {
        anyPrevClaimsExp
        prevClaimExpDesc
      }
      isKutchaConstruct
      policyType
      tenure {
        code
        value
      }
      policyStartDate
      policyExpiryDate
      riskLocations {
        riskLocationID
        occupancyCodeValue {
          code
          value
          occupancySection
          occupancyRate
          riskCode
          rateCode
          riskGrade
          riskGradeDefinition
          riskPreference
          gicClass
          stfiRate
          rsmdRate
        }
        riskLocAddress {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
          location
          zone
          eqZone
          locationCode
          isSamePremises
          allIndiaBasisDesc
        }
        buildingSI
        plantMachinerySI
        furnitureFixtureSI
        rawMaterialSI
        otherContentsSI
        stockSI
        stocksInProcessSI
        stockOnFloaterBasis
        floaterLocations {
          address_line1
          address_line2
          address_line3
          land_mark
          city
          district
          state
          pin_code
          location
          zone
          eqZone
          locationCode
          isSamePremises
          allIndiaBasisDesc
        }
        maxStockSIAtOneLoc
        locationSI
        fireExtinguishApplisDtls {
          applianceCode
          applianceValue
          isSelected
        }
        constructionClass
        waterbodyDistance
        securityProvisions
        loadingPct
        discountPct
        prevClaimExpDesc
        premium {
          locationNetPremium
          locationGST
          locationTotalPremium
          stampDuty
          warningMsg
        }
      }
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      clauses {
        default
        userDefined
      }
      warranties {
        default
        userDefined
      }
      conditions {
        default
        userDefined
      }
      exclusions {
        default
        userDefined
      }
      finalisedPremium {
        locNetPremium
        locGST
        locTotalPremium
        stampDuty
      }
      financierDtls {
        financerName
        financerAddress
        financerAgreementType
        loanAccountNumber
        fileNumber
      }
      uploadedDocuments {
        documentType {
          code
          value
        }
        documentName
        documentSize
        base64EncodedDoc
      }
      underwriterComment
      userID
    }
  }
`;
export const VIEW_PROPOSAL_FIRESF = gql`
  query viewProposalSF($input: viewProposalInput) {
    viewProposalSF(input: $input) {
      customerID
      proposalNumber
      proposalStatus
      policyNumber
      quoteNumber
      TypeofBusiness
      IsApplicableForPayment
      Proposal_Payment_Type
      startDate
      endDate
      Sum_Insured
      intermediaryDetails {
          code
          location
          fieldUserCode
          fieldUserName
      }
        finalisedPremium {
          locNetPremium
          locGST
          locTotalPremium
          stampDuty
      }
      ThirdGrid_Details
        {
            Occupancy_Name  
            Cost_Of_Construction
            Carpet_Area
            Building_Value
            Additional_Structure
            TotalBuilding_Sum_Insured
            GeneralContentSI 
            ValuableContentSI
            TotalContentSI
            Total_SI
            Type_Of_Cover
        }
    }
  }
`;
export const DOCUMENT_STATIC_DATA = gql`
  query documentExtensions {
    documentExtensions {
      code
      value
    }
    docFileSizeLimit {
      code
      value
    }
    #docAddLimit {
    #code
    #value
    #}
    docDescCharacterLimit {
      code
      value
    }
  }
`;


export const GET_DOCUMENTS_INFO = gql`
  query documentsInfo($input: IDInput) {
    getDocumentsForCustomer(input: $input) {
      documentID
      documentName
      documentFileName
      documentExtension
      documentSize
      documentDescription
    }
  }
`;

